export default "__VITE_ASSET__5op4IqwK__"